(function () {
    'use strict';
    var $ = angular.element,
        rStateName = /^\s*([^(]*)/i,
        templateUrl = 'app/shared/tab-set/tab.component.html';

    angular
        .module('app.shared')
        .component('sc3Tab', {
            templateUrl: templateUrl,
            controller: TabComponent,
            transclude: 'element',
            require: { tabSet: '^sc3TabSet' },
            bindings: {
                title: '@',
                state: '@',
                icon: '@'
            }
        });


    TabComponent.$inject = ['$element', '$scope', '$attrs', '$compile', '$state', '$templateRequest', '$transitions', '$timeout', 'mediaState'];
    function TabComponent($element, $scope, $attrs, $compile, $state, $templateRequest, $transitions, $timeout, mediaState) {
        // Variables
        var ctrl = this,
            isActive,
            placeholder,
            viewClone;

        // Properties
        Object.defineProperty(ctrl, 'isPhone', { get: getIsPhone });
        ctrl.isCollapsed = true;

        // Methods
        ctrl.$onInit = init;
        ctrl.removeClone = removeClone;

        //////////////////////////////////////////////

        // Methos
        function init() {
            $templateRequest(templateUrl)
                .then(initCompile)
                .then(initVariables)
                .then(initWatches)
        }
        function removeClone() {
            if (viewClone) {
                viewClone.remove();
                viewClone = null;
            }
        }

        // Init Helpers
        function initCompile(element) {
            element = $(element);
            // Merge Attributes.  For right now, we will just do class.
            if ($attrs.class)
                element.addClass($attrs.class);
            $element.after(element);
            $compile(element)($scope);
            return element;
        }
        function initVariables(element) {
            var match = rStateName.exec(ctrl.state),
                stateName = match && match[0];

            isActive = $state.$current.name === stateName;
            placeholder = $(element[0].querySelector('.panel-body'));
            return stateName;
        }
        function initWatches(stateName) {
            $scope.$on('$destroy', $transitions.onBefore({ to: stateName }, beginHook));
            $scope.$on('$destroy', $transitions.onSuccess({ to: stateName }, successHook));
            $scope.$on('$destroy', $transitions.onExit({ exiting: stateName }, exitHook));
            $scope.$watch('$ctrl.isPhone', phoneWatchAction)
        }

        // Transition Hooks
        function beginHook() {
            if (isActive)
                ctrl.isCollapsed = !ctrl.isCollapsed;
        }
        function successHook() {
            isActive = true;
            if (ctrl.isPhone) 
                appendView();
        }
        function exitHook() {
            var view = ctrl.tabSet.view;
            isActive = false;
            ctrl.isCollapsed = true;
            if (ctrl.isPhone) 
                placeholder.append(viewClone = view.detach().clone());
        }

        // Helpers
        function getIsPhone() {
            return mediaState.xs;
        }
        function phoneWatchAction(isPhone) {
            if (isPhone && isActive)
                appendView();
            else if (!isPhone) {
                ctrl.isCollapsed = true;
                removeClone();
            }
        }
        function appendView() {
            $timeout(function () {
                placeholder.append(ctrl.tabSet.view);
                ctrl.isCollapsed = false;
            });
        }
    }
})();